import $ from "jquery";

$.validator.addMethod("requiredif", function(value, element, parameters) {
    let desiredvalue = parameters.desiredvalue;
    desiredvalue = (desiredvalue == null ? "" : desiredvalue).toString();
    const controlType = $("input[name$='" + parameters.dependentproperty + "']").attr("type");
    let actualvalue = {};
    if (controlType === "checkbox" || controlType === "radio") {
        const control = $("input[name$='" + parameters.dependentproperty + "']:checked");
        actualvalue = control.val();
    } else {
        actualvalue = $(element).closest("form").find("[name=" + parameters.dependentproperty + "]").val();
    }
    const desiredvalues = desiredvalue.split(",");
    for (let i = 0; i < desiredvalues.length; i++) {
        if ($.trim(desiredvalues[i]).toLowerCase() === $.trim(actualvalue).toLocaleLowerCase()) {
            return $.validator.methods.required.call(this, value, element, parameters);
        }
    }
    return true;
});
$.validator.unobtrusive.adapters.add("requiredif", ["dependentproperty", "desiredvalue"], function(options) {
    options.rules.requiredif = options.params;
    options.messages.requiredif = options.message;
});